<ng-container>
    <form class="popup-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="field full-width">
            <label>{{ 'identificationPopup.input' | translate }}</label>
            <input
                    pInputText
                    placeholder="12345"
                    formControlName="identification"
                    required
            />
            @if (form.controls.identification.touched && form.controls.identification.hasError('required')) {
                <small class="p-error">
                    {{ 'identificationPopup.required' | translate }}
                </small>
            }
        </div>

        <div class="dialog-actions">
            <p-button type="submit" [disabled]="form.invalid">
                <i class="pi pi-plus"></i>
                {{ "button.add" | translate | uppercase }}
            </p-button>
        </div>
    </form>
</ng-container>
